import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 10px;
  & .react-datepicker-wrapper,
  & .react-datepicker__input-container {
    width: 100%;
  }
  & input {
    background-color: #fbf8f1;
    border-radius: 100px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
    min-height: 41px;
    width: 100%;
    padding: 10px 18px;
    color: hsl(0, 0%, 20%);
    font-size: 13px;
    font-family: 'Overpass', sans-serif;
    border: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &:focus {
      outline: none;
      border-color: #cacaca;
    }
  }
  ${props =>
    props.error &&
    `
    & input{
      border: 1px solid red !important;
    }
  
  `};
`
const Label = styled.div`
  width: 100%;
  position: relative;
  color: #91a8b0;
  font-size: 12px;
  padding: 5px 0px;
  & span {
    color: red;
  }
`

const Datepicker = ({ ...props }) => {
  return (
    <Wrapper error={props.error}>
      <Label>{props.label}</Label>
      <DatePicker dateFormat="dd/MM/yyyy" {...props} />
    </Wrapper>
  )
}

export default Datepicker



// WEBPACK FOOTER //
// ./src/components/Datepicker.js